import React, { memo } from 'react';
export const PainSection = () => {
  return <section className="bg-familia-card py-10 md:py-16 px-4 md:px-6" data-id="element-146" data-mp="1rrc96dmk6pkc">
      <div className="max-w-4xl mx-auto w-[92%] md:w-full text-center" data-id="element-147" data-mp="38wlq4hzku8cg">
        <h2 className="text-[22px] sm:text-3xl md:text-4xl font-display font-bold mb-6 leading-tight" data-id="element-148" data-mp="2uyx8rk4pxjc5">
          You already want to help. You just need a simpler way to know what to
          do each day.
        </h2>

        <p className="text-familia-gray text-[16px] md:text-xl leading-relaxed max-w-3xl mx-auto" data-id="element-149" data-mp="2l7kg4qb3ip52">
          No more searching through random websites, saving activities you may
          never use or wondering whether you're doing enough.{' '}
          <span className="text-familia-cyan font-bold" data-id="element-150" data-mp="2g995wegw2cmb">Vitality 360™</span>{' '}
          puts everything in one place, so you can spend less time searching and
          more time being present. That's exactly why it was created.
        </p>
      </div>
    </section>;
};